// import RulePack from './RulePack';

export default {
  priority: 4,
  path: "packet",
  permissions: ["RequestsMenu/RequestPattern/PatternDefinitionMenu"],
  // component: RulePack,
  component: load(() =>
    import(/* webpackChunkName: "Request-pattern-RulePack" */ "./RulePack")
  ),
  name: app.translate("آیتم های حقوق و دستمزد"),
  icon: "content-paste",
  drawer: true,
};
